import React from "react";

const Linkedin = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true" 
      focusable="false"
    >
      <g clipPath="url(#clip0_2581_7844)">
        <path d="M4.54684 6.65625H0.25V19.5598H4.54684V6.65625Z" fill="white" />
        <path
          d="M18.6461 7.83739C17.7435 6.85211 16.5497 6.35938 15.0654 6.35938C14.5185 6.35938 14.0214 6.42664 13.5743 6.56127C13.1273 6.69581 12.7498 6.88458 12.4415 7.12766C12.1335 7.37074 11.8881 7.5964 11.706 7.80464C11.5327 8.00244 11.3634 8.23284 11.1981 8.49348V6.65864H6.91406L6.9272 7.28373C6.936 7.70052 6.94033 8.98516 6.94033 11.1378C6.94033 13.2907 6.93167 16.0988 6.91424 19.5623H11.1981V12.3617C11.1981 11.9191 11.2456 11.5676 11.3412 11.3069C11.5237 10.864 11.799 10.4932 12.1681 10.1938C12.5372 9.8941 12.995 9.74437 13.542 9.74437C14.2883 9.74437 14.8376 10.0026 15.1892 10.5191C15.5407 11.0355 15.7164 11.7495 15.7164 12.661V19.5619H20.0003V12.1666C20 10.2653 19.5489 8.82235 18.6461 7.83739Z"
          fill="white"
        />
        <path
          d="M2.42183 0.445312C1.70143 0.445312 1.11772 0.655968 0.670549 1.07687C0.223425 1.49786 0 2.02936 0 2.67186C0 3.30538 0.216995 3.83505 0.65103 4.26029C1.08493 4.68557 1.65793 4.89832 2.3697 4.89832H2.39574C3.12499 4.89832 3.71317 4.68575 4.16016 4.26029C4.60715 3.83505 4.82629 3.30556 4.81767 2.67186C4.809 2.0294 4.58749 1.49786 4.15359 1.07687C3.71974 0.655786 3.14227 0.445312 2.42183 0.445312Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2581_7844">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Linkedin;
